import {defineSlotRecipe, defineRecipe} from '@chakra-ui/react3'

export const promotionBannerRecipe = defineRecipe({
    base: {
        width: 'full',
        position: 'relative',
        backgroundColor: 'background.section.strong',
        color: 'text.primary',
        borderRadius: 'xs',
        paddingBlock: 'spacing-16',
        paddingInline: 'spacing-16',
        '--container-inline-padding': {base: 'spacing.spacing-24', s: 'spacing.spacing-32'},
        '--container-total-inline-padding': {base: 'spacing.spacing-24', s: 'spacing.spacing-32'}
    }
})

export const promotionItemRecipe = defineSlotRecipe({
    slots: ['root', 'content', 'iconBox', 'heading'],
    base: {
        root: {},
        content: {
            color: 'text.primary',
            textStyle: 'body.small'
        },
        iconBox: {
            padding: 'spacing-6',
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden',
            borderRadius: 'full',
            justifyContent: 'center',
            width: '1.75rem',
            height: '1.75rem',
            backgroundColor: 'primary.base.white'
        },
        heading: {
            textStyle: 'headings.small'
        }
    },
    variants: {
        colorWorld: {
            cream: {
                iconBox: {backgroundColor: 'secondary.cream'},
                heading: {color: 'secondary.cream'}
            },
            malva: {
                iconBox: {backgroundColor: 'secondary.malva'},
                heading: {color: 'secondary.malva'}
            },
            terracotta: {
                iconBox: {backgroundColor: 'secondary.terracotta'},
                heading: {color: 'secondary.terracotta'}
            },
            fjordblue: {
                iconBox: {backgroundColor: 'secondary.fjordBlue'},
                heading: {color: 'secondary.fjordBlue'}
            },
            cherry: {
                iconBox: {backgroundColor: 'secondary.cherry'},
                heading: {color: 'secondary.cherry'}
            },
            pinegreen: {
                iconBox: {backgroundColor: 'secondary.pineGreen'},
                heading: {color: 'secondary.pineGreen'}
            },
            sunflower: {
                iconBox: {backgroundColor: 'secondary.sunflower'},
                heading: {color: 'secondary.sunflower'}
            }
        }
    }
})

export const sliderNavigationButtonVariant = {
    black: 'mediaGhost'
}

export const sliderPaginationVariant = {
    black: 'mediaGhost'
}
